import * as React from 'react'
import {connect} from "react-redux";
import {ApplicationState} from "../../store"
import {Button, Paper, IconButton} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import DeleteIcon from '@material-ui/icons/Delete'
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionContractDelete, actionContractFetch, actionContractSave} from "../../store/contracts/actions"
import {Role} from "../../models/Role"
import FileUploader from "../../core/components/FileUploader"
import {Utility} from "../../core/Utility"
import {actionActiveTabTitle, actionDeleteTab, actionSetTabState} from "../../store/tabs/actions"
import {DeleteConfirmation} from "../components/DeleteConfirmation"
import {Tab} from "../Tab"
import {Validator} from "../../core/Validator"
import {ContractDescriptor} from "../../models/Contract"
import {PopupDialog} from "../../core/components/PopupDialog"
import {actionCustomerFetchAll} from "../../store/customers"
import {Customer} from "../../models/Customer"
import {t} from "../../core/localization"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {contractFieldsDescriptor} from "./ContractFields"

export interface ContractTabProps extends BaseTabProps{
	roles: Role[]
	tab: Tab
	customers: Customer[]
}

export interface ContractTabState extends BaseTabState{
	isDeleteConfirmationDialogOpen: boolean;
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		roles: state.roles.list,
		tab: state.tabs.active,
		customers: state.customers.list
	}
}

class ContractTab extends BaseTab<ContractTabProps, ContractTabState> {

	constructor(props: ContractTabProps) {
		super(props)
		this.state = {isDeleteConfirmationDialogOpen: false, isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: ContractTabProps) {
	}

	componentDidMount() {
		actionCustomerFetchAll()
		if (this.props.item.id) actionContractFetch(this.props.item)
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '10px'}}>
				{this.renderTabControls()}
				<div style={{display:'flex', flexDirection:'row', flex:'2', marginTop: '10px' }}>
					<div style={{flex:'1', marginRight: '20px'}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderFormControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						<Paper style={{padding:'10px'}}>
							{this.props.item.id && <FileUploader
								itemId={this.props.item.id}
								itemType={'Contracts'}
								uploads={this.props.item.uploads}
								onUpload={this.onUpload.bind(this)}
								onDelete={this.onFileDelete.bind(this)}/>}
							{!this.props.item.id && <p style={{textAlign: 'center'}}>{t.SaveItem}</p>}
						</Paper>
					</div>
				</div>
				{this.renderDeleteConfirmationDialog()}
				{this.renderPopupDialog()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = contractFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Customers: {
				return this.props.customers.map((customer: Customer) => {return {label: customer.title, value: customer.id}})
			}
		}
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderTabControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={this.openDeleteConfirmationModal.bind(this)}>
				<DeleteIcon />
			</IconButton>
		</div>
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {

		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, ContractDescriptor)

		if (validation.valid) {
			actionContractSave(itemToSave)
			actionActiveTabTitle(t.Contract + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state, validation: validation });
	}

	onUpload () {
		actionContractFetch(this.props.item)
	}

	onFileDelete () {
		actionContractFetch(this.props.item)
	}

	openDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true});
	}

	onToggleDeleteConfirmationModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen});
	}

	onDeleteConfirmClick(){
		actionContractDelete(this.props.item)
		actionDeleteTab(this.props.tab)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	protected handleCustomersAutocompleteChange(value: any, name: string) {

		if(value && value.id) {

			let selectedCustomerId = value.id;
			let item: any = this.props.item;
			let tabState = this.props.state;
			if (!tabState['item']) tabState['item'] = Utility.clone(item);
			tabState['item']['contractId'] = '';
			tabState['item']['customerId'] = selectedCustomerId;

			// change tab state
			actionSetTabState(tabState);
		}
	}
}

export default connect(mapStateToProps)(ContractTab);
